<template>
  <Modal
    header-tag="h1"
    :show="status"
    :resetListener="resetListener"
    :thinFormat="true"
    @close="$emit('close')"
  >
    <!-- HEADER -->
    <template #header>
      <VisibleText>Create an account to start analyzing your feedback data</VisibleText>
    </template>
    <p style="margin-top: -1rem; text-align: center">
      Share your work email and a brief description of your work so we can tailor your experience
      and best support you.
    </p>
    <div class="register-small__org-promo">
      For organizations: If your use case fits, we’ll activate a 30‑day enterprise trial and guide
      you through your first project.
    </div>

    <RegisterSmall @registered="handleSubmitted" />
  </Modal>
</template>

<script>
import Modal from '@/components/UI/Modal.vue';
import RegisterSmall from '@/components/Register/RegisterSmall.vue';

export default {
  name: 'RegisterSmallModal',
  components: {
    Modal,
    RegisterSmall,
  },
  props: {
    status: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      resetListener: false,
    };
  },
  methods: {
    handleSubmitted(payload) {
      // Pass data upward to LandingPage or wherever
      this.$emit('registered', payload);
      this.$emit('close');
    },
  },
};
</script>
<style>
.register-small__org-promo {
  margin: auto;
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding: 0.85rem 1rem;
  background: #e0f2fe; /* light blue accent background */
  border-left: 3px solid #0ea5e9; /* your accent blue */
  border-radius: 6px;
  font-size: 0.9rem;
  color: #0b2740; /* navy text for contrast */
  line-height: 1.45;
  font-weight: 500;
  text-align: center;
  width: 40%;
}
</style>
